"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageDetailFilterSensitiveLog = exports.DescribeImagesRequestFilterSensitiveLog = exports.DeleteRepositoryPolicyResponseFilterSensitiveLog = exports.DeleteRepositoryPolicyRequestFilterSensitiveLog = exports.DeleteRepositoryResponseFilterSensitiveLog = exports.DeleteRepositoryRequestFilterSensitiveLog = exports.CreateRepositoryResponseFilterSensitiveLog = exports.RepositoryFilterSensitiveLog = exports.RepositoryCatalogDataFilterSensitiveLog = exports.CreateRepositoryRequestFilterSensitiveLog = exports.TagFilterSensitiveLog = exports.RepositoryCatalogDataInputFilterSensitiveLog = exports.CompleteLayerUploadResponseFilterSensitiveLog = exports.CompleteLayerUploadRequestFilterSensitiveLog = exports.BatchDeleteImageResponseFilterSensitiveLog = exports.ImageFailureFilterSensitiveLog = exports.BatchDeleteImageRequestFilterSensitiveLog = exports.ImageIdentifierFilterSensitiveLog = exports.BatchCheckLayerAvailabilityResponseFilterSensitiveLog = exports.LayerFilterSensitiveLog = exports.LayerFailureFilterSensitiveLog = exports.BatchCheckLayerAvailabilityRequestFilterSensitiveLog = exports.AuthorizationDataFilterSensitiveLog = exports.ReferencedImagesNotFoundException = exports.LayersNotFoundException = exports.InvalidLayerPartException = exports.ImageTagAlreadyExistsException = exports.ImageDigestDoesNotMatchException = exports.ImageAlreadyExistsException = exports.RegistryAliasStatus = exports.ImageNotFoundException = exports.RepositoryPolicyNotFoundException = exports.RepositoryNotEmptyException = exports.TooManyTagsException = exports.RepositoryAlreadyExistsException = exports.LimitExceededException = exports.InvalidTagParameterException = exports.UploadNotFoundException = exports.UnsupportedCommandException = exports.LayerPartTooSmallException = exports.LayerAlreadyExistsException = exports.InvalidLayerException = exports.EmptyUploadException = exports.ImageFailureCode = exports.ServerException = exports.RepositoryNotFoundException = exports.RegistryNotFoundException = exports.InvalidParameterException = exports.LayerAvailability = exports.LayerFailureCode = void 0;
exports.UploadLayerPartResponseFilterSensitiveLog = exports.UploadLayerPartRequestFilterSensitiveLog = exports.UntagResourceResponseFilterSensitiveLog = exports.UntagResourceRequestFilterSensitiveLog = exports.TagResourceResponseFilterSensitiveLog = exports.TagResourceRequestFilterSensitiveLog = exports.SetRepositoryPolicyResponseFilterSensitiveLog = exports.SetRepositoryPolicyRequestFilterSensitiveLog = exports.PutRepositoryCatalogDataResponseFilterSensitiveLog = exports.PutRepositoryCatalogDataRequestFilterSensitiveLog = exports.PutRegistryCatalogDataResponseFilterSensitiveLog = exports.PutRegistryCatalogDataRequestFilterSensitiveLog = exports.PutImageResponseFilterSensitiveLog = exports.PutImageRequestFilterSensitiveLog = exports.ListTagsForResourceResponseFilterSensitiveLog = exports.ListTagsForResourceRequestFilterSensitiveLog = exports.InitiateLayerUploadResponseFilterSensitiveLog = exports.InitiateLayerUploadRequestFilterSensitiveLog = exports.ImageFilterSensitiveLog = exports.GetRepositoryPolicyResponseFilterSensitiveLog = exports.GetRepositoryPolicyRequestFilterSensitiveLog = exports.GetRepositoryCatalogDataResponseFilterSensitiveLog = exports.GetRepositoryCatalogDataRequestFilterSensitiveLog = exports.GetRegistryCatalogDataResponseFilterSensitiveLog = exports.RegistryCatalogDataFilterSensitiveLog = exports.GetRegistryCatalogDataRequestFilterSensitiveLog = exports.GetAuthorizationTokenResponseFilterSensitiveLog = exports.GetAuthorizationTokenRequestFilterSensitiveLog = exports.DescribeRepositoriesResponseFilterSensitiveLog = exports.DescribeRepositoriesRequestFilterSensitiveLog = exports.DescribeRegistriesResponseFilterSensitiveLog = exports.RegistryFilterSensitiveLog = exports.RegistryAliasFilterSensitiveLog = exports.DescribeRegistriesRequestFilterSensitiveLog = exports.DescribeImageTagsResponseFilterSensitiveLog = exports.ImageTagDetailFilterSensitiveLog = exports.ReferencedImageDetailFilterSensitiveLog = exports.DescribeImageTagsRequestFilterSensitiveLog = exports.DescribeImagesResponseFilterSensitiveLog = void 0;
const ECRPUBLICServiceException_1 = require("./ECRPUBLICServiceException");
var LayerFailureCode;
(function (LayerFailureCode) {
    LayerFailureCode["InvalidLayerDigest"] = "InvalidLayerDigest";
    LayerFailureCode["MissingLayerDigest"] = "MissingLayerDigest";
})(LayerFailureCode = exports.LayerFailureCode || (exports.LayerFailureCode = {}));
var LayerAvailability;
(function (LayerAvailability) {
    LayerAvailability["AVAILABLE"] = "AVAILABLE";
    LayerAvailability["UNAVAILABLE"] = "UNAVAILABLE";
})(LayerAvailability = exports.LayerAvailability || (exports.LayerAvailability = {}));
class InvalidParameterException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidParameterException.prototype);
    }
}
exports.InvalidParameterException = InvalidParameterException;
class RegistryNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RegistryNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RegistryNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RegistryNotFoundException.prototype);
    }
}
exports.RegistryNotFoundException = RegistryNotFoundException;
class RepositoryNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryNotFoundException.prototype);
    }
}
exports.RepositoryNotFoundException = RepositoryNotFoundException;
class ServerException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ServerException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServerException.prototype);
    }
}
exports.ServerException = ServerException;
var ImageFailureCode;
(function (ImageFailureCode) {
    ImageFailureCode["ImageNotFound"] = "ImageNotFound";
    ImageFailureCode["ImageReferencedByManifestList"] = "ImageReferencedByManifestList";
    ImageFailureCode["ImageTagDoesNotMatchDigest"] = "ImageTagDoesNotMatchDigest";
    ImageFailureCode["InvalidImageDigest"] = "InvalidImageDigest";
    ImageFailureCode["InvalidImageTag"] = "InvalidImageTag";
    ImageFailureCode["KmsError"] = "KmsError";
    ImageFailureCode["MissingDigestAndTag"] = "MissingDigestAndTag";
})(ImageFailureCode = exports.ImageFailureCode || (exports.ImageFailureCode = {}));
class EmptyUploadException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "EmptyUploadException",
            $fault: "client",
            ...opts,
        });
        this.name = "EmptyUploadException";
        this.$fault = "client";
        Object.setPrototypeOf(this, EmptyUploadException.prototype);
    }
}
exports.EmptyUploadException = EmptyUploadException;
class InvalidLayerException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidLayerException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidLayerException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidLayerException.prototype);
    }
}
exports.InvalidLayerException = InvalidLayerException;
class LayerAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayerAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayerAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayerAlreadyExistsException.prototype);
    }
}
exports.LayerAlreadyExistsException = LayerAlreadyExistsException;
class LayerPartTooSmallException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayerPartTooSmallException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayerPartTooSmallException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayerPartTooSmallException.prototype);
    }
}
exports.LayerPartTooSmallException = LayerPartTooSmallException;
class UnsupportedCommandException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "UnsupportedCommandException",
            $fault: "client",
            ...opts,
        });
        this.name = "UnsupportedCommandException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnsupportedCommandException.prototype);
    }
}
exports.UnsupportedCommandException = UnsupportedCommandException;
class UploadNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "UploadNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "UploadNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UploadNotFoundException.prototype);
    }
}
exports.UploadNotFoundException = UploadNotFoundException;
class InvalidTagParameterException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidTagParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidTagParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidTagParameterException.prototype);
    }
}
exports.InvalidTagParameterException = InvalidTagParameterException;
class LimitExceededException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
    }
}
exports.LimitExceededException = LimitExceededException;
class RepositoryAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryAlreadyExistsException.prototype);
    }
}
exports.RepositoryAlreadyExistsException = RepositoryAlreadyExistsException;
class TooManyTagsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "TooManyTagsException",
            $fault: "client",
            ...opts,
        });
        this.name = "TooManyTagsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TooManyTagsException.prototype);
    }
}
exports.TooManyTagsException = TooManyTagsException;
class RepositoryNotEmptyException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryNotEmptyException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryNotEmptyException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryNotEmptyException.prototype);
    }
}
exports.RepositoryNotEmptyException = RepositoryNotEmptyException;
class RepositoryPolicyNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryPolicyNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryPolicyNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryPolicyNotFoundException.prototype);
    }
}
exports.RepositoryPolicyNotFoundException = RepositoryPolicyNotFoundException;
class ImageNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageNotFoundException.prototype);
    }
}
exports.ImageNotFoundException = ImageNotFoundException;
var RegistryAliasStatus;
(function (RegistryAliasStatus) {
    RegistryAliasStatus["ACTIVE"] = "ACTIVE";
    RegistryAliasStatus["PENDING"] = "PENDING";
    RegistryAliasStatus["REJECTED"] = "REJECTED";
})(RegistryAliasStatus = exports.RegistryAliasStatus || (exports.RegistryAliasStatus = {}));
class ImageAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageAlreadyExistsException.prototype);
    }
}
exports.ImageAlreadyExistsException = ImageAlreadyExistsException;
class ImageDigestDoesNotMatchException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageDigestDoesNotMatchException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageDigestDoesNotMatchException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageDigestDoesNotMatchException.prototype);
    }
}
exports.ImageDigestDoesNotMatchException = ImageDigestDoesNotMatchException;
class ImageTagAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageTagAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageTagAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageTagAlreadyExistsException.prototype);
    }
}
exports.ImageTagAlreadyExistsException = ImageTagAlreadyExistsException;
class InvalidLayerPartException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidLayerPartException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidLayerPartException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidLayerPartException.prototype);
        this.registryId = opts.registryId;
        this.repositoryName = opts.repositoryName;
        this.uploadId = opts.uploadId;
        this.lastValidByteReceived = opts.lastValidByteReceived;
    }
}
exports.InvalidLayerPartException = InvalidLayerPartException;
class LayersNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayersNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayersNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayersNotFoundException.prototype);
    }
}
exports.LayersNotFoundException = LayersNotFoundException;
class ReferencedImagesNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ReferencedImagesNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ReferencedImagesNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ReferencedImagesNotFoundException.prototype);
    }
}
exports.ReferencedImagesNotFoundException = ReferencedImagesNotFoundException;
const AuthorizationDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.AuthorizationDataFilterSensitiveLog = AuthorizationDataFilterSensitiveLog;
const BatchCheckLayerAvailabilityRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.BatchCheckLayerAvailabilityRequestFilterSensitiveLog = BatchCheckLayerAvailabilityRequestFilterSensitiveLog;
const LayerFailureFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.LayerFailureFilterSensitiveLog = LayerFailureFilterSensitiveLog;
const LayerFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.LayerFilterSensitiveLog = LayerFilterSensitiveLog;
const BatchCheckLayerAvailabilityResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.BatchCheckLayerAvailabilityResponseFilterSensitiveLog = BatchCheckLayerAvailabilityResponseFilterSensitiveLog;
const ImageIdentifierFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ImageIdentifierFilterSensitiveLog = ImageIdentifierFilterSensitiveLog;
const BatchDeleteImageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.BatchDeleteImageRequestFilterSensitiveLog = BatchDeleteImageRequestFilterSensitiveLog;
const ImageFailureFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ImageFailureFilterSensitiveLog = ImageFailureFilterSensitiveLog;
const BatchDeleteImageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.BatchDeleteImageResponseFilterSensitiveLog = BatchDeleteImageResponseFilterSensitiveLog;
const CompleteLayerUploadRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CompleteLayerUploadRequestFilterSensitiveLog = CompleteLayerUploadRequestFilterSensitiveLog;
const CompleteLayerUploadResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CompleteLayerUploadResponseFilterSensitiveLog = CompleteLayerUploadResponseFilterSensitiveLog;
const RepositoryCatalogDataInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RepositoryCatalogDataInputFilterSensitiveLog = RepositoryCatalogDataInputFilterSensitiveLog;
const TagFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.TagFilterSensitiveLog = TagFilterSensitiveLog;
const CreateRepositoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateRepositoryRequestFilterSensitiveLog = CreateRepositoryRequestFilterSensitiveLog;
const RepositoryCatalogDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RepositoryCatalogDataFilterSensitiveLog = RepositoryCatalogDataFilterSensitiveLog;
const RepositoryFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RepositoryFilterSensitiveLog = RepositoryFilterSensitiveLog;
const CreateRepositoryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.CreateRepositoryResponseFilterSensitiveLog = CreateRepositoryResponseFilterSensitiveLog;
const DeleteRepositoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteRepositoryRequestFilterSensitiveLog = DeleteRepositoryRequestFilterSensitiveLog;
const DeleteRepositoryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteRepositoryResponseFilterSensitiveLog = DeleteRepositoryResponseFilterSensitiveLog;
const DeleteRepositoryPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteRepositoryPolicyRequestFilterSensitiveLog = DeleteRepositoryPolicyRequestFilterSensitiveLog;
const DeleteRepositoryPolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DeleteRepositoryPolicyResponseFilterSensitiveLog = DeleteRepositoryPolicyResponseFilterSensitiveLog;
const DescribeImagesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeImagesRequestFilterSensitiveLog = DescribeImagesRequestFilterSensitiveLog;
const ImageDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ImageDetailFilterSensitiveLog = ImageDetailFilterSensitiveLog;
const DescribeImagesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeImagesResponseFilterSensitiveLog = DescribeImagesResponseFilterSensitiveLog;
const DescribeImageTagsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeImageTagsRequestFilterSensitiveLog = DescribeImageTagsRequestFilterSensitiveLog;
const ReferencedImageDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ReferencedImageDetailFilterSensitiveLog = ReferencedImageDetailFilterSensitiveLog;
const ImageTagDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ImageTagDetailFilterSensitiveLog = ImageTagDetailFilterSensitiveLog;
const DescribeImageTagsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeImageTagsResponseFilterSensitiveLog = DescribeImageTagsResponseFilterSensitiveLog;
const DescribeRegistriesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeRegistriesRequestFilterSensitiveLog = DescribeRegistriesRequestFilterSensitiveLog;
const RegistryAliasFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RegistryAliasFilterSensitiveLog = RegistryAliasFilterSensitiveLog;
const RegistryFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RegistryFilterSensitiveLog = RegistryFilterSensitiveLog;
const DescribeRegistriesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeRegistriesResponseFilterSensitiveLog = DescribeRegistriesResponseFilterSensitiveLog;
const DescribeRepositoriesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeRepositoriesRequestFilterSensitiveLog = DescribeRepositoriesRequestFilterSensitiveLog;
const DescribeRepositoriesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.DescribeRepositoriesResponseFilterSensitiveLog = DescribeRepositoriesResponseFilterSensitiveLog;
const GetAuthorizationTokenRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetAuthorizationTokenRequestFilterSensitiveLog = GetAuthorizationTokenRequestFilterSensitiveLog;
const GetAuthorizationTokenResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetAuthorizationTokenResponseFilterSensitiveLog = GetAuthorizationTokenResponseFilterSensitiveLog;
const GetRegistryCatalogDataRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRegistryCatalogDataRequestFilterSensitiveLog = GetRegistryCatalogDataRequestFilterSensitiveLog;
const RegistryCatalogDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.RegistryCatalogDataFilterSensitiveLog = RegistryCatalogDataFilterSensitiveLog;
const GetRegistryCatalogDataResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRegistryCatalogDataResponseFilterSensitiveLog = GetRegistryCatalogDataResponseFilterSensitiveLog;
const GetRepositoryCatalogDataRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRepositoryCatalogDataRequestFilterSensitiveLog = GetRepositoryCatalogDataRequestFilterSensitiveLog;
const GetRepositoryCatalogDataResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRepositoryCatalogDataResponseFilterSensitiveLog = GetRepositoryCatalogDataResponseFilterSensitiveLog;
const GetRepositoryPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRepositoryPolicyRequestFilterSensitiveLog = GetRepositoryPolicyRequestFilterSensitiveLog;
const GetRepositoryPolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.GetRepositoryPolicyResponseFilterSensitiveLog = GetRepositoryPolicyResponseFilterSensitiveLog;
const ImageFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ImageFilterSensitiveLog = ImageFilterSensitiveLog;
const InitiateLayerUploadRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.InitiateLayerUploadRequestFilterSensitiveLog = InitiateLayerUploadRequestFilterSensitiveLog;
const InitiateLayerUploadResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.InitiateLayerUploadResponseFilterSensitiveLog = InitiateLayerUploadResponseFilterSensitiveLog;
const ListTagsForResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListTagsForResourceRequestFilterSensitiveLog = ListTagsForResourceRequestFilterSensitiveLog;
const ListTagsForResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.ListTagsForResourceResponseFilterSensitiveLog = ListTagsForResourceResponseFilterSensitiveLog;
const PutImageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutImageRequestFilterSensitiveLog = PutImageRequestFilterSensitiveLog;
const PutImageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutImageResponseFilterSensitiveLog = PutImageResponseFilterSensitiveLog;
const PutRegistryCatalogDataRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutRegistryCatalogDataRequestFilterSensitiveLog = PutRegistryCatalogDataRequestFilterSensitiveLog;
const PutRegistryCatalogDataResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutRegistryCatalogDataResponseFilterSensitiveLog = PutRegistryCatalogDataResponseFilterSensitiveLog;
const PutRepositoryCatalogDataRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutRepositoryCatalogDataRequestFilterSensitiveLog = PutRepositoryCatalogDataRequestFilterSensitiveLog;
const PutRepositoryCatalogDataResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.PutRepositoryCatalogDataResponseFilterSensitiveLog = PutRepositoryCatalogDataResponseFilterSensitiveLog;
const SetRepositoryPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SetRepositoryPolicyRequestFilterSensitiveLog = SetRepositoryPolicyRequestFilterSensitiveLog;
const SetRepositoryPolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.SetRepositoryPolicyResponseFilterSensitiveLog = SetRepositoryPolicyResponseFilterSensitiveLog;
const TagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.TagResourceRequestFilterSensitiveLog = TagResourceRequestFilterSensitiveLog;
const TagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.TagResourceResponseFilterSensitiveLog = TagResourceResponseFilterSensitiveLog;
const UntagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UntagResourceRequestFilterSensitiveLog = UntagResourceRequestFilterSensitiveLog;
const UntagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UntagResourceResponseFilterSensitiveLog = UntagResourceResponseFilterSensitiveLog;
const UploadLayerPartRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UploadLayerPartRequestFilterSensitiveLog = UploadLayerPartRequestFilterSensitiveLog;
const UploadLayerPartResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
exports.UploadLayerPartResponseFilterSensitiveLog = UploadLayerPartResponseFilterSensitiveLog;
